var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39359 12L4.07862 7L5.56681 5.55L8.33059 8.15V0H10.4566V8.15L13.2204 5.55L14.7085 7L9.39359 12ZM3.01563 16C2.43099 16 1.93067 15.8043 1.51469 15.413C1.0987 15.0217 0.890357 14.5507 0.889648 14V11H3.01563V14H15.7715V11H17.8975V14C17.8975 14.55 17.6895 15.021 17.2735 15.413C16.8576 15.805 16.3569 16.0007 15.7715 16H3.01563Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/IconDownload.87b835208114496664df3ef58cb75ea0.svg";
export { ForwardRef as ReactComponent };